module.exports = __webpack_public_path__ + "static/media/S1N4-1.5e3cf700.svg";